var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPrice)?_c('div',{staticClass:"offer-original-price",style:(_vm.customStyle)},[_vm._v(" "+_vm._s(_vm.formattedPrice)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }